import * as React from "react";
import { observer } from "mobx-react";
import { withStores } from "stores";
import { MadMarqueeProps } from "./typings";
import { CustomerNotification, CustomerNotificationLocation } from "@shared-ui/customer-notifications";

export const MadMarquee = withStores(
  "flexModuleModelStore",
  "context",
  "page"
)(
  observer((props: MadMarqueeProps) => {
    const { page } = props;

    if (!page || !page.pageId) {
      return null;
    }

    return (
      <div className="MadMarqueeContainer">
        <CustomerNotification
          inputs={{
            xPageId: page.pageId,
            notificationLocation: CustomerNotificationLocation.FOOTER,
          }}
        />
      </div>
    );
  })
);

export default MadMarquee;
